export const ICON_PLACEMENT = {
  left: 'left',
  right: 'right',
}

export const SIZE = {
  sm: 'sm',
  md: 'md'
}
